export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    systems: {
      key: 'systems',
      name: 'entity.spaceStation.situation.systems',
    },
    sabotage: {
      key: 'sabotage',
      name: 'entity.spaceStation.situation.sabotage',
    },
    market: {
      key: 'market',
      name: 'entity.spaceStation.situation.market',
    },
    pretech: {
      key: 'pretech',
      name: 'entity.spaceStation.situation.pretech',
    },
    pirates: {
      key: 'pirates',
      name: 'entity.spaceStation.situation.pirates',
    },
  },
};
